// Общий выбор разделов каталога: таб «Каталог» настроек и диалог публикации пишут
// одно и то же поле categoryIds, поэтому контрол ровно один.
import { CheckCardGroup, Skeleton } from '@teach/ui'
import { pickLangField } from '@/lib/localizedText'
import { useGetCategoriesQuery } from '@/features/categories/categoriesApi'
import { useMessages, useUiLang } from '@/i18n'
import { messages } from './messages'

interface Props {
  value: number[]
  onChange: (next: number[]) => void
  disabled?: boolean
  /** Причина блокировки — «нет прав», а не «идёт сохранение». Только она даёт тултип. */
  noPermission?: boolean
}

export const CategoryPicker = ({
  value,
  onChange,
  disabled = false,
  noPermission = false,
}: Props) => {
  // Находка 5: без languageFilter бэк берёт язык ПРОФИЛЯ автора, а не язык
  // курса. Этому контролу нужен ПОЛНЫЙ список разделов независимо от языка —
  // иначе назначить курсу раздел (или снять уже назначенный, выпавший из
  // списка) для автора с чужим языком профиля нельзя.
  const m = useMessages(messages)
  const lang = useUiLang()
  const { data: categories = [], isLoading } = useGetCategoriesQuery({
    kind: 'course',
    languageFilter: 'all',
  })

  // Пока список едет — скелет карточек той же сетки, а не пустое место,
  // в которое через секунду «прыгают» разделы.
  if (isLoading) {
    return (
      <div className="grid grid-cols-2 gap-3">
        {Array.from({ length: 6 }, (_, i) => (
          <Skeleton key={i} className="h-[60px] rounded-2xl" />
        ))}
      </div>
    )
  }

  if (categories.length === 0) {
    return <p className="text-sm text-muted-foreground">{m.noCategories}</p>
  }

  // disabled уезжает в сам CheckCardGroup: pointer-events-none гасит только мышь,
  // Tab+Space по карточкам всё равно слал бы PUT (403 для не-автора).
  return (
    <div title={noPermission ? m.noRights : undefined}>
      <CheckCardGroup
        options={categories.map((c) => ({
          id: String(c.id),
          label: pickLangField(c.nameRu, c.nameEn, lang),
        }))}
        value={value.map(String)}
        onChange={(next) => onChange(next.map(Number))}
        disabled={disabled}
      />
    </div>
  )
}
